import {computed, Service, signal} from '@angular/core'
import {getDefaultUser} from '../general/shared'

@Service()
export class UserService {

  // Temporary till I get this from the BE
  public user = signal(getDefaultUser())

  // If the user is admin
  public adminUser = computed(() => this.user().scopes
    .includes('admin'))
}
